import _ from 'lodash'

/**
 * Reduces legend sections and data object for finance table into usable data for graph and graph data table
 * @param {object} firmData Data object for firm values, filetered by year
 * @param {object} sectorData Data object for sector values, filetered by year
 * @param {array} legendSections Legend definining sections in finance table, necessary because sections contain keys to values in data
 * @returns {array} Array of objects containing prefix (type), firm and optionally sector and firm/sector difference
 */
// eslint-disable-next-line
export const reduceData = (firmData, sectorData, legendSections) =>
    _.reduce(
        legendSections,
        (acc, value) => [
            ...acc,
            ..._.reduce(
                _.get(value, 'rows', []),
                (rowsAcc, row) => {
                    const columnCode = _.get(row, 'columnCode', null)
                    const prefix = _.get(row, 'prefix', null)
                    const text = _.get(row, 'text', null)
                    const firmValue = _.get(firmData, `values.${columnCode}`, null)
                    const sectorValue = _.get(sectorData, `sectorAverage.${columnCode}`, null)
                    const firmVersusSectorValue = Math.round(100 + ((firmValue - sectorValue) / sectorValue) * 100)

                    return [
                        ...rowsAcc,
                        {
                            type: prefix,
                            text: `${prefix} - ${text}`,
                            firm: firmValue,
                            sector: sectorValue,
                            sectorBasePercentage: 100, // Sector is used as base in radar graph, which means sector value is always shown as 100%
                            firmVersusSector: !_.isFinite(firmVersusSectorValue) ? 0 : firmVersusSectorValue,
                        },
                    ]
                },
                []
            ),
        ],
        []
    )
